<!-- Support kézikönyv — design: erp-design/screens/09-support-kezikonyv.html,
     tartalom: support-szabalykonyv.txt (SOP v1.0 · 2026-07-07) -->
<div class="kb">

  <!-- Fejléc -->
  <div class="kb__head">
    <div class="kb__head-main">
      <div class="kb__title-row">
        <button type="button" class="kb__back" title="Vissza a Supporthoz" routerLink="/support">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="11,6 5,12 11,18"></polyline></svg>
        </button>
        <h1 class="stk-page-title">Support kézikönyv</h1>
      </div>
      <div class="stk-page-sub kb__sub">Mire vagy jogosult, mit csinálhatsz, mit írj a vevőnek — szabályok és mintaszövegek. v1.0 · 2026-07-07</div>
    </div>
  </div>

  <!-- Kereső -->
  <div class="kb__search">
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#9AA098" stroke-width="2" stroke-linecap="round"><circle cx="10.5" cy="10.5" r="6.5"></circle><line x1="15.5" y1="15.5" x2="20" y2="20"></line></svg>
    <input class="kb__search-input" [ngModel]="search" (ngModelChange)="onSearchChange($event)"
           placeholder="Keresés témára, problémára, szövegre… (pl. törött, lemondás, kupon, adószám)">
    <span class="kb__search-count">{{ resultLabel }}</span>
  </div>

  <div class="kb__grid">
    <!-- Kategóriák -->
    <div class="kb__cats">
      <button type="button" class="kb-cat" *ngFor="let chip of catChips; trackBy: trackChip"
              [class.kb-cat--on]="chip.on" [class.kb-cat--zero]="chip.zero && !chip.on"
              (click)="pickCat(chip.label)">
        {{ chip.label }}
        <span class="kb-cat__count" [class.kb-cat__count--on]="chip.on">{{ chip.count }}</span>
      </button>
    </div>

    <!-- Cikkek -->
    <div class="kb__articles">
      <div class="kb-article" *ngFor="let vm of list; trackBy: trackArticle">
        <div class="kb-article__head" (click)="toggle(vm)">
          <span class="kb-article__chevron">{{ vm.chevron }}</span>
          <span class="kb-article__title">{{ vm.article.title }}</span>
          <span class="kb-article__prio" *ngIf="vm.article.prio" [ngClass]="vm.prioClass">{{ vm.article.prio }}</span>
          <span class="kb-article__cat">{{ vm.article.cat }}</span>
        </div>

        <div class="kb-article__body" *ngIf="vm.open">
          <div class="kb-article__rules" *ngIf="vm.article.rules.length > 0">
            <div class="kb-rule" *ngFor="let rule of vm.article.rules">
              <span class="kb-rule__bullet">•</span>
              <span>{{ rule }}</span>
            </div>
          </div>

          <!-- Táblázat (prioritás-tábla / gyors döntési tábla) -->
          <div class="kb-table-wrap" *ngIf="vm.article.table as table">
            <table class="kb-table">
              <thead>
                <tr>
                  <th *ngFor="let header of table.headers">{{ header }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of table.rows">
                  <td *ngFor="let cell of row">{{ cell }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Mintaszövegek -->
          <div class="kb-article__templates" *ngIf="vm.templates.length > 0">
            <div class="kb-template" *ngFor="let template of vm.templates">
              <div class="kb-template__head">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#8A9464" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12 a8 8 0 1 0 -3.1 6.3 L21 20 Z"></path></svg>
                <span class="kb-template__label">Mintaszöveg — {{ template.label }}</span>
                <button type="button" class="kb-template__copy" (click)="copy(template, 'hu')">{{ template.huBtn }}</button>
                <button type="button" class="kb-template__copy" (click)="copy(template, 'en')">{{ template.enBtn }}</button>
              </div>
              <div class="kb-template__grid">
                <div class="kb-template__col">
                  <div class="kb-template__lang">HU</div>
                  <div class="kb-template__text">{{ template.hu }}</div>
                </div>
                <div class="kb-template__col kb-template__col--en">
                  <div class="kb-template__lang">EN</div>
                  <div class="kb-template__text">{{ template.en }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Üres állapot -->
      <div class="kb__empty" *ngIf="empty">
        <div class="kb__empty-title">Nincs találat</div>
        <div class="kb__empty-text">Próbáld más szóval — vagy ha a szabály hiányzik, hozz létre eszkalációs taskot Attilának.</div>
      </div>
    </div>
  </div>
</div>
